
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiFetch } from '../utils/api'; // Ensure correct path to your api.js
import '../App.css';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/';

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    setIsLoading(true);

    try {
      const data = await apiFetch('/api/users/login', 'POST', { username, password });

      if (data.success && data.token) {
        localStorage.setItem('token', data.token);
        login(data.token);
        setSuccessMessage('✅ Login successful! Redirecting...');

        setTimeout(() => {
          navigate(from, { replace: true });
        }, 1500);
      } else {
        setErrorMessage(data.message || '❌ Login failed. Try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage(error.message || 'Network error. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container page-container mt-5" style={{ maxWidth: '400px' }}>
      <h2 className="text-center text-primary">Log In to ProTechTion</h2>

      {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
      {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}

      <form onSubmit={handleLogin} className="mt-4">
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <input
            type="password"
            className="form-control"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Log In'}
        </button>
      </form>

      <div className="text-center mt-3">
        <a href="/request-password-reset">Forgot your password?</a>
      </div>
    </div>
  );
};

export default Login;
